(function(angular, jwtDecode) {
    'use strict';

    class AuthTokenService {
        getCookie(cname){
            let name = cname + '=';
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(';');
            for(let i = 0; i <ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        }

        getDecodedJWT() {
            let decodedGydaToken = null,
                gydaToken;

            try {
                gydaToken = JSON.parse(this.getCookie('gydaToken'));
                decodedGydaToken = jwtDecode(gydaToken.token);
            }
            catch (e) {}
            finally {
                return decodedGydaToken;
            }
        }

            isTokenExpired() {
                let now,
                    decodedGydaToken,
                    isExpired = false;

                try {
                    decodedGydaToken = this.getDecodedJWT();

                    now = new Date().getTime();
                    if(decodedGydaToken === null || (decodedGydaToken && decodedGydaToken.exp && decodedGydaToken.exp < now)) {
                        isExpired = true;
                    }

                } catch (e) {
                    isExpired = true;
                }
                finally {
                    return isExpired;
                }

            }
    }
    angular
        .module('MW.influencers.AuthTokenService', [])
        .service('AuthTokenService',[
            AuthTokenService
        ]);

}(window.angular, window.jwtDecode));